<template>
  <div class="dash-orb" aria-hidden="true">
    <div class="dash-orb__ring dash-orb__ring--1" />
    <div class="dash-orb__ring dash-orb__ring--2" />
    <div class="dash-orb__ring dash-orb__ring--3" />
    <div class="dash-orb__core">
      <v-icon icon="mdi-creation" size="32" class="dash-orb__icon" />
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'DashboardAiOrb' })
</script>
